/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BackgroundTaskItemGet,
  BackgroundTaskTypeGet,
  BackgroundTaskTypeUpdate,
  GetItemsListParams,
  GetTypesListParams,
  StartPayload,
  StopPayload,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class BackgroundTasks<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags BackgroundTasks
   * @name GetItemsList
   * @summary Получить активные фоновые процессы
   * @request GET:/BackgroundTasks/list
   * @secure
   * @response `200` `(BackgroundTaskItemGet)[]` Фоновые задачи
   */
  getItemsList = (query: GetItemsListParams, params: RequestParams = {}) =>
    this.request<BackgroundTaskItemGet[], any>({
      path: `/BackgroundTasks/list`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BackgroundTasks
   * @name GetTypesList
   * @summary Получить список типов фоновых процессов
   * @request GET:/BackgroundTasks/types
   * @secure
   * @response `200` `(BackgroundTaskTypeGet)[]` Типы фоновых прцоессов
   */
  getTypesList = (query: GetTypesListParams, params: RequestParams = {}) =>
    this.request<BackgroundTaskTypeGet[], any>({
      path: `/BackgroundTasks/types`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BackgroundTasks
   * @name UpdateTaskType
   * @summary Обновление фоновой задачи
   * @request POST:/BackgroundTasks/updateType/{code}
   * @secure
   * @response `200` `void` Success
   */
  updateTaskType = (code: string, data: BackgroundTaskTypeUpdate, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/BackgroundTasks/updateType/${code}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags BackgroundTasks
   * @name Start
   * @summary Запуск выбранных фоновых задач
   * @request POST:/BackgroundTasks/start
   * @secure
   * @response `200` `void` Success
   */
  start = (data: StartPayload, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/BackgroundTasks/start`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags BackgroundTasks
   * @name Stop
   * @summary Остановка выбранных фоновых задач
   * @request POST:/BackgroundTasks/stop
   * @secure
   * @response `200` `void` Success
   */
  stop = (data: StopPayload, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/BackgroundTasks/stop`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
